import React from 'react';
import { JoinerEditorTabs, JoinerEditorHeader, JoinerEditorButtons } from '../joinerEditor';
import Edit from '../editForms/edit/TextStimEdit';
import Options from '../editForms/options/TextStimOptions';
import Timing from '../editForms/timing/Timing';
import Rules from '../editForms/rules/Rules';

class TextStimEditor extends React.Component {
  render() {
    const { props } = this;
    return (
      <>
        <JoinerEditorTabs tabs={props.tabs} joinerInfo={props.joinerInfo} hideMedia hideTiming={props.isScreener} />
        <div className="joiner-editor">
          <JoinerEditorHeader {...props} />
          <div className="joiner-editor-form">
            <Edit {...props} />
            <Options {...props} />
            <Timing {...props} />
            <Rules {...props} />
          </div>
          <JoinerEditorButtons
            toggle={props.toggle}
            saveEnabled={props.saveEnabled}
            saveJoiner={props.saveJoiner}
            readOnly={props.readOnly}
          />
        </div>
      </>
    );
  }
}

export default TextStimEditor;
